const enJSON = {
    dailyOrders: 'Daily Orders',
    dailyQuotes: 'Daily Quotes',
    monthlyOrders: 'Monthly Order',
    monthlyQuotes: 'Monthly Quotes'
};

export default enJSON;
